/**
 * Generates a UUID using the ES2021 Crypto.randomUUID function.
 */
export function uuid(): string {
    return crypto.randomUUID();
}
